export default class LoginService {
    constructor(ctx) {
        this.$http = ctx
    }

    login({ username, password, recaptcha_token }) {
        return this.$http.fetchData("/login", {
            method: "POST",
            body: JSON.stringify({ username, password, recaptcha_token }),
        })
    }

    init() {
        return this.$http.fetchData("/init")
    }

    logout() {
        return this.$http.fetchData("/logout", { method: "POST" })
    }

    loginChangePassword({ newPassword, repeatNewPassword }) {
        return this.$http.fetchData("/login-change-password", {
            method: "PUT",
            body: JSON.stringify({ newPassword, repeatNewPassword }),
        })
    }

    loginDataPolicy(id) {
        return this.$http.fetchData("/login-data-policy", {
            method: "POST",
            body: JSON.stringify({ disclaimerId: id }),
        })
    }

    getAuthenticationOptions({ userId, token }) {
        return this.$http.fetchData(
            `two-factor-authentication-options/${userId}/${token}`,
            {
                method: "GET",
            }
        )
    }

    requestAuthenticationCode({ option, userId, token }) {
        return this.$http.fetchData(
            `two-factor-authentication-send-code/${userId}/${token}`,
            {
                method: "POST",
                body: JSON.stringify({ option }),
            }
        )
    }

    refreshAuthenticationOptions({ userId, token }) {
        return this.$http.fetchData(
            `two-factor-authentication/${userId}/${token}`,
            {
                method: "GET",
            }
        )
    }

    validateAuthenticationCode({ userId, token, code2fa }) {
        return this.$http
            .fetchData(
                `two-factor-authentication-validate-code/${userId}/${token}`,
                {
                    method: "POST",
                    body: JSON.stringify({ code2fa }),
                }
            )
            .then(response => {
                return response[0]
            })
    }

    deleteAuthenticationAttempt({ userId, token }) {
        return this.$http.fetchData(
            `two-factor-authentication-delete-attempt/${userId}/${token}`,
            {
                method: "POST",
            }
        )
    }
}
